import React from 'react';
import { TiltCard } from './ui/TiltCard';
import { Globe, Zap, Crown, Check } from 'lucide-react';
import { motion } from 'framer-motion';
const services = [{
  icon: Globe,
  title: 'Starter',
  desc: 'Get a professional website built and launched for your business in just one day.',
  monthlyPrice: '£97/mo',
  results: ['Free Website', 'On-Page SEO', 'SSL & Fast Loading', 'Lead Capture System']
}, {
  icon: Zap,
  title: 'Unlimited',
  desc: 'Automate your Google reviews and grow your online reputation hands-free.',
  monthlyPrice: '£297/mo',
  results: ['Everything in Starter', 'CRM + Lead Tracking', 'SMS, Email & Review Automations', 'Google 5 Star Reviews Automation', '24/7 Live AI ChatBot']
}, {
  icon: Crown,
  title: 'Pro',
  desc: 'Full automation with AI that handles leads and customers around the clock.',
  monthlyPrice: '£497/mo',
  results: ['Everything in Unlimited', '24/7 Live AI Receptionist', 'Automatic Appointments Booking Automation']
}];
export function ServicesSection() {
  const handleGetStarted = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return;
}